// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"541":"0ce8aa10","703":"474d77f9"}[chunkId] + ".chunk.js";
};